<template>
    <Modal :show="show" @close="close()" className="p-0 pb-5">
      <header class="feature" :style="answerImage"></header>
        <div class="modal-main ml-5 mr-5 text-center">
          <h2>{{ question }}</h2>
          <span v-html="answer"></span><br/>
          <a @click.prevent="close" href="#" class="btn btn-outline-primary mt-3">{{ buttonText }}</a>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/models/Modal'
export default {
  name: 'ModalAnswer',
  extends: Modal,
  props: ['question', 'answer', 'action', 'colour', 'image'],
  components: {
    Modal
  },
  computed: {
    buttonText () {
      if (this.action && this.action.length > 0) {
        return this.action
      }
      return 'Close'
    },
    answerImage () {
      return 'background: url(/static/modal/' + this.image + ') no-repeat; background-size: cover;'
    },
    getColor () {
      return 'background-color: ' + this.colour
    },
    enableSurveys: function () {
      // return true
      return process.env.ENABLE_SURVEYS === 'true' || false // .env by default are strings
    }
  }
}
</script>

<style scoped lang="scss">
  .modal-body {
      padding-bottom:1.5rem;

  }
  .modal-main {
    h2 {
      font-family: Athelas;
      font-size:32px;
      color: #002e6e;
    }
    span{
      font-family: Roboto;
      font-size: 18px;
      line-height: 1.5rem;
      color: #475363
    }
  }
  button {
    margin: 2rem auto 0;
  }


  .btn.plain.btn-booking {
      color: #3F9FCF;
      font-size:1.125rem;
  }

  .feature{
    align-items: center;
    text-align:center;

    span{
      color:#000;
      display:block;
      width:100%;
      margin:0px !important;
      font-size:30px;
    }
  }
  .modal-main{
    font-size:20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/models/ModalAnswer.vue